// extracted by mini-css-extract-plugin
export default {"card":"gnlENNi12OBB8kjwod9K","apr":"QtetlBYAwd0QeheVOejc"};